"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _vueSvgicon = _interopRequireDefault(require("vue-svgicon"));
/* eslint-disable */
/* tslint:disable */
// @ts-ignore

_vueSvgicon.default.register({
  'delivery-truck': {
    width: 16,
    height: 16,
    viewBox: '0 0 412.005 412.005',
    data: '<path pid="0" d="M0 283.525c0 4.224 2.96 7.539 7.184 7.539h11.47c7.707-17 25.254-29.864 45.628-29.864 20.375 0 37.918 12.864 45.629 29.864H259v-61H0v53.461z"/><path pid="1" d="M64.282 277.32c-18.673 0-33.81 15.137-33.81 33.81 0 18.673 15.137 33.81 33.81 33.81 18.664-.021 33.789-15.146 33.81-33.81 0-18.672-15.137-33.81-33.81-33.81zM407.6 205.217l-32.2-14.153H275v100h19.488c7.712-17 25.254-29.864 45.628-29.864s37.921 12.864 45.628 29.864h19.072c4.224 0 7.184-3.315 7.184-7.539v-71.034a7.774 7.774 0 00-4.4-7.274zM342.295 133.408a22.967 22.967 0 00-20.73-12.344H275v54h88.915l-21.62-41.656zM236.036 67.064H22.844C9.985 67.064 0 77.65 0 90.509v123.555h259V90.509l.001-.108c.103-12.785-10.179-23.234-22.965-23.337z"/><path pid="2" d="M340.114 277.32c-18.673.001-33.81 15.138-33.809 33.811.001 18.673 15.138 33.81 33.811 33.809 18.664-.021 33.788-15.146 33.809-33.81v-.001c-.001-18.672-15.138-33.809-33.811-33.809z"/>'
  }
});